module.exports = __webpack_public_path__ + "media/images/dummy-9321e2431944aa687e9f598b0245bd88.png";